import { FC } from 'react';

import { useTranslations } from 'context/translations';
import { LandingPageContentKeys } from 'service/contentful/keys';
import { UserCommentList } from 'components';

import styles from './UserCommentsBlock.module.css';

export const UserCommentsBlock: FC = () => {
  const { content } = useTranslations();
  return (
    <div className={styles.container}>
      <UserCommentList
        comments={content(LandingPageContentKeys.UserReviewsBlockContent)}
      />
    </div>
  );
};
